import { render, staticRenderFns } from "./PisoMenu.vue?vue&type=template&id=3624811d&scoped=true"
import script from "./PisoMenu.vue?vue&type=script&lang=js"
export * from "./PisoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624811d",
  null
  
)

export default component.exports